"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_slick_1 = __importDefault(require("react-slick"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require("./slider.scss");
const svgIcons_1 = require("../../../../svgIcons");
const common_1 = require("../../../../utils/common");
class Slider extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            sliderSettings: {
                dots: false,
                infinite: false,
                arrows: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: this.props.initialSlide,
            },
            navSettings: {
                dots: false,
                centerMode: true,
                infinite: false,
                variableWidth: true,
                arrows: false,
                swipeToSlide: true,
                focusOnSelect: true,
                slidesToShow: 1,
                initialSlide: this.props.initialSlide
            },
            mainSlider: null,
            navSlider: null,
            token: localStorage.getItem('token'),
            activeImg: null
        };
        this.sliderContainer = react_1.createRef();
        this.sliderRef = react_1.createRef();
        this.navRef = react_1.createRef();
        // remove slider from DOM
        this.unmountSlider = () => this.sliderContainer.current.remove();
        this.escKeyFunction = (e) => {
            if (e.keyCode === 27) {
                this.props.closeSlider();
                //this.unmountSlider()
            }
        };
    }
    componentDidMount() {
        const body = document.getElementsByTagName('body')[0];
        const slickTrack = document.querySelector('.nav-container.slick-slider .slick-track');
        const { media } = this.props.chat;
        const SLIDER_NAV_HEIGHT = 106;
        this.setState({
            mainSlider: this.sliderRef,
            navSlider: this.navRef,
            activeImg: media[this.props.initialSlide]
        });
        body.appendChild(this.sliderContainer.current);
        if (media.length === 1) {
            slickTrack.style.justifyContent = 'center';
        }
        document.addEventListener('keydown', this.escKeyFunction, false);
        if (common_1.isMobileBrowser().check) {
            const sliderContainer = document.querySelector(".slider-container");
            if (sliderContainer) {
                const CONTAINER_TOP = common_1.isMobileBrowser().ios ? 105 : 50;
                const containerHeight = window.innerHeight - SLIDER_NAV_HEIGHT - CONTAINER_TOP;
                //@ts-ignore
                sliderContainer.style.height = `${containerHeight}px`;
            }
        }
    }
    componentWillUnmount() {
        this.props.closeSlider();
        this.unmountSlider();
    }
    downloadImg(imgObj) {
        const url = `${imgObj.url}?token=${this.state.token}&originName=${imgObj.name}`;
        if (common_1.ifMobile()) {
            //@ts-ignore
            cordova.InAppBrowser.open(url, '_system', 'location=no');
        }
        else if (common_1.isMobileBrowser().check) {
            window.open(url, '_blank');
        }
        else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = imgObj.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    render() {
        const { media } = this.props.chat;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { ref: this.sliderContainer, className: "slider-wrapper" },
                react_1.default.createElement(svgIcons_1.CloseIcon, { onClick: () => {
                        this.props.closeSlider();
                        this.unmountSlider();
                    }, className: 'close-icon' }),
                react_1.default.createElement(react_slick_1.default, Object.assign({}, this.state.sliderSettings, { afterChange: (i) => this.setState({ activeImg: media[i] }), asNavFor: this.state.navSlider, ref: slider => (this.sliderRef = slider), className: "slider-container" }), media.map((el, i) => react_1.default.createElement("img", { key: i, className: 'slider-img', src: `${common_1.covertUrl(el)}?token=${this.state.token}`, alt: "uploaded media" }))),
                react_1.default.createElement("div", { style: { position: "relative", width: '100%' } },
                    react_1.default.createElement("a", { className: 'download-link', target: '_blank', onClick: () => this.downloadImg(this.state.activeImg) },
                        react_1.default.createElement(svgIcons_1.DownloadIcon, { style: { color: '#fff' } }),
                        react_1.default.createElement("span", null, "Download")),
                    react_1.default.createElement(react_slick_1.default, Object.assign({ className: 'nav-container' }, this.state.navSettings, { ref: slider => (this.navRef = slider), asNavFor: this.state.mainSlider }), media.map((el, i) => react_1.default.createElement("div", { key: i, className: 'item' },
                        react_1.default.createElement("img", { src: `${common_1.covertUrl(el)}?w=140&h=140&token=${this.state.token}`, alt: "uploaded media" }))))))));
    }
}
;
const mapStateToProps = (state) => {
    const { chat, user } = state;
    return {
        chat,
        user
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(Slider);
